/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Carplay_Sign_In_PromptInputs */

const en_mobile_carplay_sign_in_prompt = /** @type {(inputs: Mobile_Carplay_Sign_In_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to Listening on your iPhone to see your library`)
};

const es_mobile_carplay_sign_in_prompt = /** @type {(inputs: Mobile_Carplay_Sign_In_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión en Listening en tu iPhone para ver tu biblioteca`)
};

/**
* | output |
* | --- |
* | "Sign in to Listening on your iPhone to see your library" |
*
* @param {Mobile_Carplay_Sign_In_PromptInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_carplay_sign_in_prompt = /** @type {((inputs?: Mobile_Carplay_Sign_In_PromptInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Carplay_Sign_In_PromptInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_carplay_sign_in_prompt(inputs)
	return en_mobile_carplay_sign_in_prompt(inputs)
});